// extracted by mini-css-extract-plugin
export var container = "CaseHero-module--container--a3YcD";
export var header = "CaseHero-module--header--uTrzA";
export var hero_image = "CaseHero-module--hero_image--Mh1hZ";
export var image = "CaseHero-module--image--Nsye+";
export var innercontainer = "CaseHero-module--innercontainer--DZrfG";
export var limitWidthOnLargeScreens = "CaseHero-module--limitWidthOnLargeScreens--3ax7S";
export var subtitle = "CaseHero-module--subtitle--gcC2a";
export var tab_image = "CaseHero-module--tab_image--U9YC8";
export var title = "CaseHero-module--title--PshFS";